import React from "react";

const NewFile = () => {
  return <div>
    <h2> Hello World </h2>
    <p>
        the navigatin is working in netlify deploy ,yeap!
    </p>
  </div>;
};

export default NewFile;
